import {KTCardBody} from '../../_metronic/helpers'

function TableTemplate(props) {
  const {getTableProps, getTableBodyProps, headerGroups, page, prepareRow, nonSortableColumns} =
    props

  return (
    <KTCardBody>
      <div className="table-responsive small">
        <div className="table " {...getTableProps()} id="table-to-xls">
          <div className="thead">
            {headerGroups.map((headerGroup) => (
              <div className="tr" {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <div className="th" {...column.getHeaderProps()}>
                    {nonSortableColumns.includes(column.Header) ? (
                      <span>{column.render('Header')}</span>
                    ) : (
                      <span {...column.getSortByToggleProps()}>
                        {column.render('Header')}
                        <i
                          className={`ms-2 fa-solid ${
                            column.isSorted
                              ? column.isSortedDesc
                                ? 'fa-sort-up'
                                : 'fa-sort-down'
                              : 'fa-sort'
                          }`}
                        ></i>
                      </span>
                    )}
                  </div>
                ))}
              </div>
            ))}
          </div>

          <div className="tbody pt-2" {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row)
              return (
                <div className="tr" {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <div className="td" {...cell.getCellProps()}>
                        {cell.render('Cell')}
                      </div>
                    )
                  })}
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </KTCardBody>
  )
}

export default TableTemplate
